import ClickTracker from '@/components/Common/ClickTracker';
import BaseButton from '@/components/Common/DesignSystem/BaseButton/BaseButton';
import ImpressionDivWrapper from '@/components/Common/ImpressionDivWrapper';
import { getSVG } from '@/components/Common/styles/mixins';
import { NolPromotionStoreCtx } from '@/stores/NolPromotionStore';
import clsx from 'clsx';
import { observer } from 'mobx-react-lite';
import React, { FC, useCallback, useContext, useState } from 'react';

import styles from './index.module.scss';

const BrandIntro: FC = () => {
  const store = useContext(NolPromotionStoreCtx);

  const [activeChipIndex, setActiveChipIndex] = useState(0);
  const getResourcePath = useCallback((path: string): string => getSVG(`/static/images/nol-promotion/v8/${path}`), []);

  return (
    <ImpressionDivWrapper
      logData={{
        pageName: store.pageName,
        eventSectionName: '놀수록 놀라운 혜택 NOL 카드',
        motherPageVersion: store.version,
        motherPageSectionType: '',
        motherPageSectionName: '놀수록 놀라운 혜택 NOL 카드',
      }}
    >
      <div className={styles.container}>
        <div className={styles.logoContainer}>
          <img src={getResourcePath('logo_nol_card.png')} alt={'놀 로고'} className={styles.nolLogo} />
        </div>
        <div className={styles.title}>{'놀수록 놀라운 혜택\nNOL 카드'}</div>
        <div>
          <div className={styles.buttons}>
            <ClickTracker
              pageName={store.pageName}
              logData={{
                object: 'NOL 카드란?',
                objectType: 'Btn',
                objectContainer: '놀수록 놀라운 혜택 NOL 카드',
                motherPageVersion: store.version,
                motherPageSectionType: '',
                motherPageSectionName: '놀수록 놀라운 혜택 NOL 카드',
                motherPageSectionNameSubTitle: '',
                deepLinkUri: '',
              }}
            >
              <BaseButton
                as={'button'}
                className={clsx(styles.chip, activeChipIndex === 0 && styles.active)}
                onClick={() => setActiveChipIndex(0)}
              >
                NOL 카드란?
              </BaseButton>
            </ClickTracker>
            <ClickTracker
              pageName={store.pageName}
              logData={{
                object: 'NOL 포인트란?',
                objectType: 'Btn',
                objectContainer: '놀수록 놀라운 혜택 NOL 카드',
                motherPageVersion: store.version,
                motherPageSectionType: '',
                motherPageSectionName: '놀수록 놀라운 혜택 NOL 카드',
                motherPageSectionNameSubTitle: '',
                deepLinkUri: '',
              }}
            >
              <BaseButton
                as={'button'}
                className={clsx(styles.chip, activeChipIndex === 1 && styles.active)}
                onClick={() => setActiveChipIndex(1)}
              >
                NOL 포인트란?
              </BaseButton>
            </ClickTracker>
          </div>
          <div className={styles.imageContainer}>
            <img
              className={clsx(styles.nolCards, activeChipIndex !== 0 && styles.none)}
              src={getSVG('/static/images/nol-promotion/v9/nol-cards-1.png')}
              alt={'놀카드 디자인 모음'}
            />
            <img
              className={clsx(styles.ymembers, activeChipIndex !== 1 && styles.none)}
              src={getResourcePath('ymembers2.png')}
              alt={'놀카드 멤버사 로고'}
            />
          </div>
          <div className={styles.description}>
            {activeChipIndex === 0
              ? 'NOL 카드는, 국내 대표 여행 플랫폼인 NOL,NOL 인터파크(NOL 인터파크투어/NOL 티켓),트리플에서\n' +
                '놀 때마다 놀라운 혜택을 받을 수 있는 현대카드에요. NOL,NOL 인터파크(NOL 인터파크투어/NOL 티켓),트리플 중 한 곳의 회원이라면\n' +
                'NOL 카드를 이용할 수 있고 각 플랫폼에서 진행되는 모든 혜택을 받아보실 수 있습니다.'
              : 'NOL 포인트는 NOL 카드를 사용하면 쌓을 수 있는 포인트로,\n' +
                'NOL,NOL 인터파크(NOL 인터파크투어/NOL 티켓), 트리플에서 상품 결제할 때 쓸 수 있는 포인트입니다.\n' +
                '여행부터 일상까지 NOL 카드와 함께 놀며 NOL 포인트를 쌓아 더 즐겁고 스마트하게 놀아보세요.'}
          </div>
        </div>
      </div>
    </ImpressionDivWrapper>
  );
};

export default observer(BrandIntro);
